import { twMerge } from "tailwind-merge";

export function Skeleton({ className }: { className: string }) {
  return <div className={twMerge("animate-pulse bg-gray-200", className)} />;
}
